import React from 'react';
import _ from 'lodash';
import {ThemeProvider} from 'styled-components';
import sho from './sho';
import nrk from './nrk/nrk';
import nrk2 from './nrk/nrk2';
import nxs from './nxs/nxs';
import nxs2 from './nxs/nxs2';
import nxs3 from './nxs/nxs3';
import azn from './azn/azn';
import azn2 from './azn/azn2';
import djsb from './azn/djsb';
import aznOld from './azn/aznOld';
import aznOld2 from './azn/aznOld2';
import fsh from './fsh/fsh';
import fsh2 from './fsh/fsh2';
import hum from './hum/hum';
import hum2 from './hum/hum2';
import hum3 from './hum/hum3';
import hum4 from './hum/hum4';
import hum5 from './hum/hum5';
import hum6 from './hum/hum6';
import hum7 from './hum/hum7';
import amf from './amf';
import eha from './eha';
import clw from './clw';
import slc from './slc/slc';
import slc2 from './slc/slc2';
import lfs from './lfs';
import mdl from './mdl';
import nst from './nst';
import fkh from './fkh';

function getTheme(theme) {
  switch (theme) {
    case 'sho':
      return sho;
    case 'nrk':
      return nrk;
    case 'nrk2':
      return nrk2;
    case 'azn':
      return azn;
    case 'azn2':
      return azn2;
    case 'djsb':
      return djsb;
    case 'aznOld':
      return aznOld;
    case 'aznOld2':
      return aznOld2;
    case 'fsh':
      return fsh;
    case 'fsh2':
      return fsh2;
    case 'hum':
      return hum;
    case 'hum2':
      return hum2;
    case 'hum3':
      return hum3;
    case 'hum4':
      return hum4;
    case 'hum5':
      return hum5;
    case 'hum6':
      return hum6;
    case 'hum7':
      return hum7;
    case 'amf':
      return amf;
    case 'eha':
      return eha;
    case 'clw':
      return clw;
    case 'slc':
      return slc;
    case 'slc2':
      return slc2;
    case 'lfs':
      return lfs;
    case 'mdl':
      return mdl;
    case 'nst':
      return nst;
    case 'fkh':
      return fkh;
    case 'nxs':
      return nxs;
    case 'nxs2':
      return nxs2;
    case 'nxs3':
      return nxs3;
    default:
      return nxs;
  }
}

const Theme = ({store, children, themeFromState}) => (
  <ThemeProvider theme={() => {
    let theme;

    if (!_.isNil(store)) {
      const state = store.getState();
      theme = state.reducer.theme;
    } else {
      theme = themeFromState;
    }

    return getTheme(theme);
  }
  }>{children}</ThemeProvider>
);

export default Theme;
